import React from "react";
import { Button, ButtonProps, DistributiveOmit, If, useOpenToggle } from "@hex-insights/core";
import { FieldIf, FieldIfProps, FormState, FormValues } from "@hex-insights/forms";

export type FieldToggleProps<FV extends FormValues> = DistributiveOmit<FieldIfProps<FV>, "formState" | "condition"> & {
	initialIsOpen?: boolean;
	formState: FieldIfProps<FV>["formState"] & Pick<FormState<FV>, "disabled">;
	buttonVariant?: ButtonProps["variant"];
	buttonSize?: ButtonProps["size"];
	disabled?: ButtonProps["disabled"];
	buttonChildren?: ButtonProps["children"];
};

export function FieldToggle<FV extends FormValues>({
	buttonVariant,
	buttonSize,
	buttonChildren,
	disabled,
	formState,
	initialIsOpen,
	children,
	...props
}: FieldToggleProps<FV>) {
	const { isOpen, open } = useOpenToggle(initialIsOpen);

	return (
		<React.Fragment>
			<FieldIf {...props} formState={formState} condition={isOpen}>
				{children}
			</FieldIf>
			<If condition={!isOpen}>
				<Button variant={buttonVariant} size={buttonSize} onClick={open} disabled={disabled || formState.disabled}>
					{buttonChildren}
				</Button>
			</If>
		</React.Fragment>
	);
}
